import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { TfiEmail } from "react-icons/tfi";
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import AsyncSelect from 'react-select/async';
import { BarLoader, ClipLoader } from 'react-spinners';
import { LiaFileExcel } from "react-icons/lia";
import * as XLSX from "xlsx";
import { useCurrency } from '../../Layouts/currencyContext';

const ItemReports = () => {
    const [rowData, setRowData] = useState([]);
    const [paginationData, setPagination] = useState();
    const [loading, setLoading] = useState(false);
    const [StockType, setStockType] = useState();
    const { currencyPrecision } = useCurrency();
    const [precision, setPrecision] = useState(currencyPrecision?.exp1 || 3);
    const [pageSize, setPageSize] = useState(20);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [subCategoryOptions, setSubCategoryOptions] = useState([]);
    const [Location, setLocation] = useState([]);
    const apiService = new ApiService();
    const gridRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);
    const [searchLoader, setSearchLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const currentDatetimeUTC = new Date().toISOString();

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const [formData, setFormData] = useState({
        itemNo: { label: 'Select ItemNo', value: 'All' },
        ItemDescription: { label: 'Select Item', value: 'All' },
        email: "",
        Category: [{ label: 'Select Category', value: 'Select Category' }],
        SubCategory: [{ label: 'Select Sub Category', value: 'Select Sub Category' }],
        StockType: [{ label: 'Select Stock Type', value: 'Select Sub Category' }],
        Warehouse: [{ label: 'Select Ware House', value: 'Select Sub Category' }],
    });
    useEffect(() => {
        getCat()
        // getItems()
    }, []);
    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');

            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);

            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue?.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    };
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    };
    const getCat = async () => {
        let Catparam = `?Active=1`;
        let param = `?isActive=true`
        const categoryResponse = await apiService.getApiParamater("GET_CATEGORY", Catparam);
        setCategoryOptions(categoryResponse?.data?.result);
        const subCategoryResponse = await apiService.getApiParamater("GET_SUB_CATEGORY", Catparam);
        setSubCategoryOptions(subCategoryResponse?.data?.result);
        const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", param);
        setStockType(stockType?.data?.result);
        let res = await apiService.get('GET_WAREHOUSE_MASTER')
        setLocation(res?.data?.result)
    }
    const getItems = async (newPageNo = paginationData?.currentPage) => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            if (formData.itemNo.value.itemNo) {
                params.append('ItemNo', formData.itemNo.value.itemNo || '');
            }
            if (formData.itemNo.value.itemDescription) {
                params.append('ItemDescription', formData.itemNo.value.itemDescription || '');
            }
            params.append('Category', formData.Category?.value?.catCode || "0");
            params.append('SubCategory', formData.SubCategory?.value?.subcatcode || "0");
            params.append('StockType', formData.StockType?.value?.stockTypeCode || "0");
            params.append('Warehouse', formData.Warehouse?.label || "0");
            params.append('AsOnDate', currentDatetimeUTC);
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);

            const res = await apiService.getApiParamater('GET_ITEMS_REPORT', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setRowData(res?.data?.result?.reverse() || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const handleCategoryChange = (selectedOption) => {
        setFormData({ ...formData, Category: selectedOption });
    }
    const handleSubCategoryChange = (selectedOption) => {
        setFormData({ ...formData, SubCategory: selectedOption });
    }
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const handleStockChange = (selectedOption) => {
        setFormData({ ...formData, StockType: selectedOption });
    }
    const handlelocChange = (selectedOption) => {
        setFormData({ ...formData, Warehouse: selectedOption });
    }
    const handleSearch = async (page) => {
        setSearchLoader(true);
        await getItems(page);
        setSearchLoader(false);
    }
    const handleClearFilters = () => {
        setFormData({
            itemNo: { label: 'Select ItemNo', value: 'All' },
            ItemDescription: { label: 'Select Item', value: 'All' },
            email: "",
            Category: [{ label: 'Select Category', value: 'Select Category' }],
            SubCategory: [{ label: 'Select Sub Category', value: 'Select Sub Category' }],
            StockType: [{ label: 'Select Stock Type', value: 'Select Sub Category' }],
            Warehouse: [{ label: 'Select Ware House', value: 'Select Sub Category' }],
        });
        getItems()
    }
    const Comparison = [
        { headerName: 'Item Code', field: 'itemNo', suppressMovable: true, width: 120, cellClass: 'copy-item-code', },
        { headerName: 'Description ', field: 'itemDescription', suppressMovable: true, width: 500 },
        { headerName: 'Category', field: 'category', suppressMovable: true, width: 130 },
        { headerName: 'Sub Category', field: 'subCategory', suppressMovable: true, width: 150 },
        // { headerName: 'Stock Type', field: 'stockType', suppressMovable: true, width: 130 },
        { headerName: 'Packing UOM', field: 'baseUnit', suppressMovable: true, width: 130 },
        { headerName: 'Inventory UOM', field: 'unitMeasurement', suppressMovable: true, width: 125 },
        {
            headerName: 'Packing QTY', field: 'qty', suppressMovable: true, width: 130,
            valueFormatter: (params) => params?.value?.toFixed(1)
        },
        { headerName: 'Inventory Qty', field: 'inventoryQty', suppressMovable: true, width: 140 },
        { headerName: 'Warehouse', field: 'warehouseLocation', suppressMovable: true, width: 180 },
        {
            headerName: 'Unit Price', field: 'price', suppressMovable: true, width: 150,
            valueFormatter: (params) => params?.value?.toFixed(precision || 0)
        },
        {
            headerName: 'Amount', field: 'amount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(precision || 0)
        },
    ]
    const PDF_COLUMNS = [
        { header: 'Item Code', field: 'itemNo' },
        { header: 'Description', field: 'itemDescription' },
        { header: 'Category', field: 'category' },
        { header: 'Sub Category', field: 'subCategory' },
        { header: 'Packing UOM', field: 'baseUnit' },
        { header: 'Inventory UOM', field: 'unitMeasurement' },
        { header: 'Packing QTY', field: 'qty' },
        { header: 'Inventory Qty', field: 'inventoryQty' },
        { header: 'Warehouse', field: 'warehouseLocation' },
        { header: 'Unit Price', field: 'price' },
        { header: 'Amount', field: 'amount' },
    ];
    const onBtnCSVExport = useCallback(async (formdata, pagedata) => {

        setLoading(true);
        const params = new URLSearchParams();
        if (formdata.itemNo.value.itemNo) {
            params.append('ItemNo', formData.itemNo.value.itemNo);
        }
        if (formdata.itemNo.value.itemDescription) {
            params.append('ItemDescription', formdata.itemNo.value.itemDescription);
        }
        params.append('Category', formdata.Category?.value?.catCode || "0");
        params.append('SubCategory', formdata.SubCategory?.value?.subcatcode || "0");
        params.append('StockType', formdata.StockType?.value?.stockTypeCode || "0");
        params.append('Warehouse', formdata.Warehouse?.label || "0");
        params.append('AsOnDate', currentDatetimeUTC);

        // 🔴 Important: fetch ALL records
        params.append('PageNo', 1);
        params.append('PageSize', pagedata?.totalRecords || 10000);

        const res = await apiService.getApiParamater(
            'GET_ITEMS_REPORT',
            `?${params.toString()}`
        );
        const allData = res?.data?.result || [];

        if (allData?.length > 0) {
            gridRef.current.api.setRowData(allData);

            gridRef.current.api.exportDataAsCsv({
                fileName: 'itemsReport.csv',
                allColumns: true,
            });
            setLoading(false);
            toast.success("itemsReport.csv downloaded")
        } else {
            toast.info("Please try Again")
        }
    }, []);
    const onBtPDFExport = useCallback(async (formdata, pagedata) => {

        const params = new URLSearchParams();
        if (formdata.itemNo.value.itemNo) {
            params.append('ItemNo', formData.itemNo.value.itemNo);
        }
        if (formdata.itemNo.value.itemDescription) {
            params.append('ItemDescription', formdata.itemNo.value.itemDescription);
        }
        params.append('Category', formdata.Category?.value?.catCode || "0");
        params.append('SubCategory', formdata.SubCategory?.value?.subcatcode || "0");
        params.append('StockType', formdata.StockType?.value?.stockTypeCode || "0");
        params.append('Warehouse', formdata.Warehouse?.label || "0");
        params.append('AsOnDate', currentDatetimeUTC);

        // 🔴 Important: fetch ALL records
        params.append('PageNo', 1);
        params.append('PageSize', pagedata?.totalRecords || 10000);

        const res = await apiService.getApiParamater(
            'GET_ITEMS_REPORT',
            `?${params.toString()}`
        );
        let gridData = res?.data?.result || [];

        if (gridData?.length > 0) {
            const doc = new jsPDF('l', 'mm', 'a4');
            const headers = PDF_COLUMNS.map(col => col.header);
            const rows = gridData.map(item =>
                PDF_COLUMNS.map(col => item[col.field] ?? '')
            );

            doc.setFontSize(16);
            doc.text('Item Master Report', 14, 15);

            doc.autoTable({
                head: [headers],
                body: rows,
                startY: 20,
                styles: {
                    fontSize: 8,
                },
                headStyles: {
                    fillColor: [209, 126, 6],
                    textColor: [255, 255, 255],
                },
                theme: 'striped',
            });

            doc.save('itemsReport.pdf');
            setLoading(false);
            toast.success("itemsReport.pdf downloaded")
        } else {
            toast.info("Please try Again")
        }
    }, []);
    const onBtnExcelExport = useCallback(async (formdata, pagedata) => {
        try {

            const params = new URLSearchParams();

            if (formdata.itemNo?.value?.itemNo) {
                params.append("ItemNo", formdata.itemNo.value.itemNo);
            }

            if (formdata.itemNo?.value?.itemDescription) {
                params.append("ItemDescription", formdata.itemNo.value.itemDescription);
            }

            params.append("Category", formdata.Category?.value?.catCode || "0");
            params.append("SubCategory", formdata.SubCategory?.value?.subcatcode || "0");
            params.append("StockType", formdata.StockType?.value?.stockTypeCode || "0");
            params.append("Warehouse", formdata.Warehouse?.label || "0");
            params.append("AsOnDate", currentDatetimeUTC);

            // Fetch all records
            params.append("PageNo", 1);
            params.append("PageSize", pagedata?.totalRecords || 10000);

            const res = await apiService.getApiParamater(
                "GET_ITEMS_REPORT",
                `?${params.toString()}`
            );

            const allData = res?.data?.result || [];

            if (!allData.length) {
                toast.info("No data found");
                setLoading(false);
                return;
            }

            const excelData = allData.map((item) => ({
                "Item Code": item.itemNo,
                "Description": item.itemDescription,
                "Category": item.category,
                "Sub Category": item.subCategory,
                "Packing UOM": item.baseUnit,
                "Inventory UOM": item.unitMeasurement,
                "Packing Qty": Number(item.qty || 0).toFixed(1),
                "Inventory Qty": item.inventoryQty,
                "Warehouse": item.warehouseLocation,
                "Unit Price": Number(item.price || 0).toFixed(precision || 0),
                "Amount": Number(item.amount || 0).toFixed(precision || 0),
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            // Auto-fit column widths
            const columnWidths = Object.keys(excelData[0]).map((header) => {
                if (header === "Description") {
                    return { wch: 60 };
                }
                const maxLength = Math.max(
                    header.length,
                    ...excelData.map((row) =>
                        row[header] ? row[header].toString().length : 0
                    )
                );

                return {
                    wch: maxLength,
                };
            });

            worksheet["!cols"] = columnWidths;

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

            XLSX.writeFile(workbook, "StockReport.xlsx");

            toast.success("StockReport.xlsx downloaded");
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    }, [precision]);
    const SendEmail = async () => {
        try {
            if (!formData.email) {
                toast.warning("Enter User Email to send Report")
                return;
            }
            const requestBody = {
                // toEmail: "shahzaibawan864@gmail.com",
                toEmail: formData.email,
                subject: "Item Report",
                body: `
                <div className='printhead2 mb-5 px-4'>
                    <table>
                        <thead className='dynoTable' style='background-color: #5B93FF; color: #fff;'>
                            <tr>
                                <th>Item Code</th>
                                <th>Description</th>
                                <th>Category</th>
                                <th>Sub Category</th>
                                <th>Stock Type</th>
                                <th>Packing UOM</th>
                                <th>Inventory UOM</th>
                                <th>Packing QTY</th>
                                <th>Inventory Qty</th>
                                <th>Warehouse</th>
                                <th>Price</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rowData?.map((row, index) => `
                                <tr key=${index}>
                                    <td className='m-0 p-0'><input style='width: 100px;' className='p-2' type='text' value='${row.itemNo}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.itemDescription}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.category}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.subCategory}' /></td>
                                    <td className='m-0 p-0'><input style='width: 80px;' className='p-2' disabled value='${row.stockType}' /></td>
                                    <td className='m-0 p-0'><input style='width: 150px;' className='p-2' disabled value='${row.baseUnit}' /></td>
                                    <td className='m-0 p-0'><input style='width: 120px;' className='p-2' disabled value='${row.unitMeasurement}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.qty}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.inventoryQty}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.warehouseLocation}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.price}' disabled /></td>
                                    <td className='m-0 p-0'><input className='p-2 w-100' type='text' value='${row.amount?.toFixed(precision || 0) || 0}' disabled /></td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>`
            }
            const apiService = new ApiService();
            const response = await apiService.post("SEND_EMAIL", requestBody);
            if (response.status === 200) {
                onCloseModal()
                toast.success("Email send successfully")
                handleClearFilters()
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleItemChange = (selectedOption) => {
        setFormData({
            ...formData,
            itemNo: selectedOption ? { label: selectedOption.value.itemNo, value: selectedOption.value } : null,
            ItemDescription: selectedOption ? { label: selectedOption.value.itemDescription, value: selectedOption.value } : null,
        });
    }

    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-8'>
                    <div className='row pb-2' >
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.itemNo}
                                options={itemOptions}
                                loadOptions={loadOptions}
                                isClearable
                                onChange={selectedOption => handleItemChange(selectedOption)}
                                defaultOptions={itemOptions}
                                onMenuScrollToBottom={loadMoreOptions}
                                noOptionsMessage={({ inputValue }) =>
                                    inputValue.length < 3
                                        ? "Type at least 3 characters..."
                                        : "No records found"
                                }
                            />
                        </div>
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.ItemDescription}
                                isClearable
                                options={descriptionOptions}
                                loadOptions={loadDescOptions}
                                onChange={selectedOption => handleItemChange(selectedOption)}
                                className="w-100 p-0"
                                defaultOptions={descriptionOptions}
                                onMenuScrollToBottom={loadMoreDescOptions}
                                noOptionsMessage={({ inputValue }) =>
                                    inputValue.length < 3
                                        ? "Type at least 3 characters..."
                                        : "No records found"
                                }
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                isClearable
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.Category}
                                onChange={(selectedOption) => handleCategoryChange(selectedOption)}
                                options={categoryOptions?.map((CatOpt) => ({ value: CatOpt, label: CatOpt?.catName }))}
                            />
                        </div>
                    </div>
                    <div className='row'  >
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                isClearable
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.SubCategory}
                                onChange={(selectedOption) => handleSubCategoryChange(selectedOption)}
                                options={subCategoryOptions?.map((SubCatOpt) => ({ value: SubCatOpt, label: SubCatOpt?.subcatname }))}
                            />
                        </div>
                        <div className='col'>
                            {/* <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                isClearable
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.StockType}
                                onChange={(selectedOption) => handleStockChange(selectedOption)}
                                options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                            /> */}
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                isClearable
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData?.Warehouse}
                                onChange={(selectedOption) => handlelocChange(selectedOption)}
                                options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                            />
                        </div>
                    </div>
                </div>
                <div className='col'></div>
                <div className='col-3 '>
                    {searchLoader === true ?
                        <button className='mainbtnGry w-100' type="button"><ClipLoader color="#ffffff" size={25} /></button> :
                        <div onClick={() => handleSearch(1)} className='mainbtnGry flex-end gap-2'>
                            <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Search</div>
                        </div>
                    }
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Stock Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2' >
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={() => onBtnCSVExport(formData, paginationData)} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtnExcelExport(formData, paginationData)} className='gap-3 d-flex center'><LiaFileExcel /><div>Export Excel</div></DropdownItem>
                                <DropdownItem onClick={() => onBtPDFExport(formData, paginationData)} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    {/* <div className='mainbtnRed flex-end '><HiOutlinePrinter size={25} /></div> */}
                    {/* <div className='mainbtn flex-end gap-1' onClick={onOpenModal}>
                        <div className='center'><TfiEmail size={25} /></div>
                    </div> */}
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 550 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            rowSelection="single"
                            columnDefs={Comparison}
                            ref={gridRef}
                            suppressExcelExport={true}
                            onCellClicked={(params) => {
                                if (params.colDef.field === 'itemNo' && params.value) {
                                    navigator.clipboard.writeText(String(params.value));
                                    toast.success('Item Code copied!');
                                }
                            }}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} pagination={paginationData} getItems={getItems} setPageSize={setPageSize} />
            </div>
            <Modal size="md"
                show={emailModal} onHide={() => setEmailModal(false)}
                backdrop="static"
                contentLabel='Email Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            type='email'
                            className="form-Input w-100"
                            id="validationCustom02"
                            value={formData.email}
                            name="email"
                            onChange={handleInputChange}
                            placeholder='Enter Email'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={SendEmail}>Save</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default ItemReports;